import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';

export const linkedBankSteps = [
	{id: 0, title: 'Mở ứng dụng GooPay, chọn icon “Tài khoản”'},
	{id: 1, title: 'Chọn “Quản lý Ví/ Thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn “Ngân hàng liên kết” trong danh sách'},
	{id: 4, title: 'Nhập thông tin cần thiết và xác thực'},
];

export const linkedBankDirectShbSteps = [
	{id: 0, title: 'Chọn “Tài khoản”'},
	{id: 1, title: 'Chọn “Quản lý ví/ thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn ngân hàng SHB trong danh sách để thực hiện liên kết'},
	{id: 4, title: 'Nhập thông tin “Số tài khoản/Số thẻ”, sau đó nhấn nút liên kết để liên kết tài khoản'},
	{id: 5, title: 'Ghi nhớ mã giao dịch tại màn hình “Xác thực”'},
	{id: 6, title: 'Vào ứng dụng SHB SAHA, chọn “Lấy mã OTP”'},
	{id: 7, title: 'Nhập mã PIN smart OTP, sau đó nhập mã giao dịch vừa ghi nhớ ở Bước 6'},
	{id: 8, title: '“Sao chép” mã xác thực vừa được tạo'},
	{id: 9, title: 'Quay về ứng dụng Ví Goopay, nhập mã xác thực vừa được sao chép'},
	{id: 10, title: 'Liên kết ngân hàng thành công. Bạn có thể bắt đầu nạp tiền vào ví Goopay'},
];

export const linkedBankDirectBidvSteps = [
	{id: 0, title: 'Chọn “Tài khoản”'},
	{id: 1, title: 'Chọn “Quản lý ví/ thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn ngân hàng BIDV trong danh sách để thực hiện liên kết'},
	{id: 4, title: 'Nhập thông tin “Số tài khoản/Số thẻ”, sau đó nhấn nút “Liên kết” để liên kết tài khoản'},
	{id: 5, title: 'Nhập mã OTP được BIDV gửi đến để xác thực'},
	{id: 6, title: 'Liên kết thành công'},
];

export const linkedBankByCardSteps = [
	{id: 0, title: 'Chọn “Tài khoản”'},
	{id: 1, title: 'Chọn “Quản lý ví/ thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn “Ngân hàng liên kết” trong danh sách'},
	{
		id: 4,
		title: 'Nhập thông tin “Số tài khoản/Số thẻ” sau đó nhấn nút liên kết để thực hiện liên kết',
		subtitle: [
			'Trường hợp người dùng nhập thông tin liên kết bằng số thẻ, người dùng cần nhập bổ sung ngày phát hành hoặc ngày hết hạn thẻ theo yêu cầu.'
		],
	},
	{
		id: 5,
		title: 'Nhập mã OTP do ngân hàng phát hành gửi về để tiến hành xác thực thông tin. Sau khi xác thực thành công, hệ thống thực hiện trừ 10.000đ từ tài khoản/thẻ và nạp vào số dư ví để hoàn tất liên kết.',
	},
	{id: 6, title: 'Liên kết thành công'},
];

export const linkedBankByAccountSteps = [
	{id: 0, title: 'Chọn “Tài khoản”'},
	{id: 1, title: 'Chọn “Quản lý ví/ thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn “Ngân hàng liên kết” trong danh sách'},
	{
		id: 4,
		title: 'Nhập thông tin “Số tài khoản/Số thẻ” sau đó nhấn nút liên kết để thực hiện liên kết',
		subtitle: [
			'Trường hợp người dùng nhập thông tin liên kết bằng số thẻ, người dùng cần nhập bổ sung ngày phát hành hoặc ngày hết hạn thẻ theo yêu cầu.'
		],
	},
	{
		id: 5,
		title: 'Nhấn “Tải ảnh” để lưu mã QR về thiết bị, sau đó dùng ảnh này trong app ngân hàng đã đăng ký để thực hiện giao dịch.',
	},
	{
		id: 6,
		title: 'Mở ứng dụng ngân hàng và chọn chức năng “Quét mã QR”',
		subtitle: [
			'Lưu ý: Giao diện mỗi ngân hàng có thể khác nhau, vui lòng chọn chức năng có biểu tượng quét mã QR trên ứng dụng ngân hàng của bạn.'
		],
	},
	{
		id: 7,
		title: 'Chọn ảnh mã QR từ thư viện ảnh',
		subtitle: [
			'Trên ứng dụng ngân hàng, chọn chức năng tải ảnh từ thư viện để sử dụng mã QR đã lưu trước đó.'
		],
	},
	{
		id: 8, title: 'Chọn ảnh mã QR đã tải về thiết bị',
		subtitle: ['Người dùng chọn đúng ảnh mã QR đã lưu để tiếp tục thực hiện giao dịch.']
	},
	{
		id: 9, title: 'Nhập số tiền 10.000 VND và xác thực giao dịch',
		subtitle: ['Sau khi quét mã thành công, người dùng nhập số tiền 10.000 VND, xác thực giao dịch theo yêu cầu của ngân hàng để hoàn tất nạp tiền vào ví Goopay.']
	},
	{
		id: 10,
		title: 'Nạp tiền và liên kết ngân hàng thành công',
		subtitle: ['Sau khi giao dịch hoàn tất, hệ thống ghi nhận nạp tiền thành công và hoàn tất liên kết ngân hàng với ví Goopay.']
	},
];

const LinkedBankContent = ({setStep, isLinkedBank, step, expandMore, data}) => {
	const steps = data ?? linkedBankSteps;
	return (
		<div className="w-full max-w-4xl py-4 px-2 md:px-4 mx-auto">
			<FeatureRichList
				data={steps}
				step={step}
				setStep={setStep}
				isLinkedBank={isLinkedBank}
				expandMore={expandMore}
				subClass='subClass'
			/>
		</div>
	);
};

export default LinkedBankContent;
